import { CloseCircleOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { ErrorColor } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconCloseCircleOutlinedError: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <CloseCircleOutlined {...props} style={{ ...props.style, color: ErrorColor }} />;
};
